import React from "react";

import {
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

import {
	Controller,
	UseFormReturn,
} from "react-hook-form";

import {
	RadioTypeProps,
	RadioTypeState,
} from "./models";

export class RadioType extends React.Component<RadioTypeProps & UseFormReturn, RadioTypeState>
{
	constructor(props: any)
	{
		super(props);

		this.state = {
			contentType: "VOD",
		};
	}

	render()
	{
		return (<Controller
			name={this.props.name}
			control={this.props.control}
			defaultValue="VOD"
			render={({field}) => (<RadioGroup
				{...field}
				row
				sx={{color: "#FFFFFF"}}>
				{this.props.valueList.map((item, index) => (<FormControlLabel key={item.key}
					value={item.key}
					control={<Radio size="small" sx={{color: "#FFFFFF"}} />}
					label={item.label}
					onClick={() => (this.props.updateType(item.key))} />))}
			</RadioGroup>)}
		/>);
	}
}
